import { Breakpoints, styled } from '@vw-marketing/us-components';

interface ArrowProps {
  readonly isNextArrow?: boolean;
}

export const StyledArrow = styled.div<ArrowProps>`
  position: absolute;
  &.slick-next,
  &.slick-prev {
    top: 40%;
    width: 22px;
    height: 22px;
    z-index: 10;
    border: solid #000;
    box-shadow: 3px 3px 2px 1px rgba(255, 255, 255, 0.7);
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 7px;
    &::before {
      display: none;
    }

    &.slick-disabled {
      pointer-events: none;
      border: solid #dfe4e8;
      border-width: 0 2px 2px 0;
      display: none;
    }
  }

  &.slick-next,
  &.slick-next button {
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    right: 20px;
    @media (min-width: ${Breakpoints.b960}px) {
      right: 26px;
    }

    @media (min-width: ${Breakpoints.b1600}px) {
      right: 60px;
    }

    @media (min-width: ${Breakpoints.b1920}px) {
      right: 90px;
    }
  }

  &.slick-prev,
  &.slick-prev button {
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
    left: 12px;
  }
`;
